module.exports = __webpack_public_path__ + "img/sw3-b3.c45b3087.jpg";